import { useQuery } from "react-query";

import api from "../../services/api";

const TEN_MINUTES = 10 * 60 * 1000;
const THIRTY_MINUTES = 30 * 60 * 1000;

const responseItems = response => response?.data?.data || [];

const loadOsCatalogs = async () => {
  const responses = await Promise.all([
    api.get("/os/cadastros/grupos", { params: { per_page: 200 } }),
    api.get("/os/cadastros/status", { params: { per_page: 200 } }),
    api.get("/os/cadastros/prioridades", { params: { per_page: 200 } }),
    api.get("/os/cadastros/tipos", { params: { per_page: 200 } }),
    api.get("/os/cadastros/canais", { params: { per_page: 200 } }),
    api.get("/os/tecnicos", { params: { per_page: 200 } }),
    api.get("/os/objetos", { params: { per_page: 200 } }),
    api.get("/os/objetos-padrao", { params: { per_page: 200 } }),
    api.get("/os/objetos-conclusao", { params: { per_page: 200 } })
  ]);

  return {
    grupos: responseItems(responses[0]),
    status: responseItems(responses[1]),
    prioridades: responseItems(responses[2]),
    tipos: responseItems(responses[3]),
    canais: responseItems(responses[4]),
    tecnicos: responseItems(responses[5]),
    objetos: responseItems(responses[6]),
    objetosPadrao: responseItems(responses[7]),
    objetosConclusao: responseItems(responses[8])
  };
};

const useOsCatalogs = () => {
  const companyId = localStorage.getItem("companyId") || "default";

  return useQuery(["os-catalogs", companyId], loadOsCatalogs, {
    staleTime: TEN_MINUTES,
    cacheTime: THIRTY_MINUTES,
    refetchOnWindowFocus: false,
    retry: 1
  });
};

export default useOsCatalogs;
